/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_ARTIST_NOTIFICATIONS = createAsyncAction(
  'GET_ARTIST_NOTIFICATIONS'
)
export const getArtistNotifications = () =>
  apiCall({
    method: 'get',
    endpoint: '/artist/notifications',
    types: GET_ARTIST_NOTIFICATIONS,
  })

export const GET_CURATOR_NOTIFICATIONS = createAsyncAction(
  'GET_CURATOR_NOTIFICATIONS'
)
export const getCuratorNotifications = () =>
  apiCall({
    method: 'get',
    endpoint: '/curator/new-playlist-extra-scores',
    types: GET_CURATOR_NOTIFICATIONS,
  })

export const MARK_CURATOR_NOTIFICATIONS_AS_READ = createAsyncAction(
  'MARK_CURATOR_NOTIFICATIONS_AS_READ'
)
export const markCuratorNotificationsAsRead = () =>
  apiCall({
    method: 'put',
    endpoint: '/curator/new-playlist-extra-scores',
    types: MARK_CURATOR_NOTIFICATIONS_AS_READ,
  })

export const MARK_ARTIST_NOTIFICATIONS_AS_READ = createAsyncAction(
  'MARK_ARTIST_NOTIFICATIONS_AS_READ'
)
export const markArtistNotificationsAsRead = () =>
  apiCall({
    method: 'put',
    endpoint: '/artist/notifications',
    types: MARK_ARTIST_NOTIFICATIONS_AS_READ,
  })

export const MARK_MOOD_TOOLTIP_AS_READ = 'MARK_MOOD_TOOLTIP_AS_READ'
export const markMoodTooltipAsRead = () => ({
  type: MARK_MOOD_TOOLTIP_AS_READ,
})

export const MARK_LANG_MODAL_AS_SHOWN = 'MARK_LANG_MODAL_AS_SHOWN'
export const markLangModalAsShown = () => ({
  type: MARK_LANG_MODAL_AS_SHOWN,
})
